import { Section } from 'components/Shared/Layout';
import { Container } from 'components/Shared/List';
import Splash from 'components/Shared/Splash';
import Button from 'components/Shared/Button';
import { IconArrow } from 'components/Shared/Icon';
import styles from './styles.scss';
import { ListViewProduct } from 'models/ListViewProduct';
import cn from 'classnames';
import { NO_ELEMENT } from 'utils';
import { ProductCard } from 'components/Shared/Product/themes/default/productCard';

interface Props {
  mostPopularProducts?: ListViewProduct[];
  mostPopularProductsTitle: string;
  productGoto: string;
  className?: string;
}
const WELCOME_SIZE = 200;

const showMostPopularProducts = (products?: ListViewProduct[]) =>
  !!(products && products.length > 0);

export const MostPopularProducts = ({
  mostPopularProductsTitle,
  mostPopularProducts,
  productGoto,
  className
}: Props) =>
  (showMostPopularProducts(mostPopularProducts) && (
    <Section
      className={cn(styles.mostPopularProducts, className)}
      title={mostPopularProductsTitle}
      appearance="primary"
      shadow
    >
      <Container items={mostPopularProducts}>
        {item => (
          <ProductCard
            appearance="start"
            picture={{
              height: WELCOME_SIZE,
              width: WELCOME_SIZE,
              className: styles.image
            }}
            {...item}
            className={styles.item}
          >
            <Splash {...item} appearance="small" />
            <Button href={item.url} className={styles.navigation}>
              {productGoto}
              <IconArrow className={styles.icon} size="small" />
            </Button>
          </ProductCard>
        )}
      </Container>
    </Section>
  )) ||
  NO_ELEMENT;
